import type { MemorySliceDescriptor, MemorySliceTuple } from "../../shared";
import { useMemorySlice } from "../../shared";
import { ephemeralStore } from "../runtime/ephemeralStore";

/**
 * Subscribes to an ephemeral slice with full-value updates.
 *
 * @typeParam TValue Slice value type.
 * @param slice Slice descriptor (stable reference from slice module).
 * @returns Tuple `[value, setValue]` compatible with `useState` updaters.
 */
export const useEphemeralSlice = <TValue>(
    slice: MemorySliceDescriptor<TValue>,
): MemorySliceTuple<TValue> => {
    return useMemorySlice( ephemeralStore, slice );
};
